import { isZspaceInternalUser } from '@order-management/roles';
import useUser from './user';

export function useIsZspaceInternalUser() {
  const { user: currentUser } = useUser();

  return isZspaceInternalUser(currentUser);
}

export default useIsZspaceInternalUser;
